import { createI18n } from 'vue-i18n'
import en from './en.json'
import ru from './ru.json'
import uz from './uz.json'
import uzCyrl from './uz-cyrl.json'

export type MessageLanguages = keyof typeof en

// Available locales
export const LOCALES = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'uz', name: 'O\'zbekcha', flag: '🇺🇿' },
    { code: 'uz-cyrl', name: 'Ўзбекча', flag: '🇺🇿' }
] as const

export type LocaleCode = typeof LOCALES[number]['code']

// Get saved locale from localStorage or Russian
function getInitialLocale(): LocaleCode {
    const saved = localStorage.getItem('locale') as LocaleCode
    if (saved && LOCALES.some(locale => locale.code === saved)) {
        return saved
    }
    // (24.10) ilk giris her zaman Rusca; kullanici dil secerse o kaydedilir ve kalir
    return 'ru'
}

// Create i18n instance
export const i18n = createI18n({
    legacy: false,
    locale: getInitialLocale(),
    fallbackLocale: 'en',
    messages: {
        en,
        ru,
        uz,
        'uz-cyrl': uzCyrl
    },
    globalInjection: true,
    warnHtmlMessage: false
})

// Helper function to change locale
export function setLocale(locale: LocaleCode) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
    document.documentElement.lang = locale
}

// Helper function to get current locale
export function getCurrentLocale(): LocaleCode {
    return i18n.global.locale.value as LocaleCode
}

// Helper function to get locale display name
export function getLocaleDisplayName(code: LocaleCode): string {
    const locale = LOCALES.find(l => l.code === code)
    return locale ? locale.name : code
}

// Helper function to get locale flag
export function getLocaleFlag(code: LocaleCode): string {
    const locale = LOCALES.find(l => l.code === code)
    return locale ? locale.flag : '🌐'
}

export default i18n